import Ext from "Ext";
import messageResource from "../../messageResource";
import {concatStr, truncateStringByLength} from "../../atUtils";

//TODO kamenev: TreeNodeHelper and SelectionHelper has similar functionality and cause partial code duplication
const TreeNodeHelper = function(config) {
    Ext.apply(this, config);
};

TreeNodeHelper.prototype = {
    /**
     * @cfg {String} itemClass specifies item node class.
     */
    itemClass: null,

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * @cfg {Array} tooltipMessageParams specifies message to be show for selectorTree item's tooltips on some
     *              specific conditions.
     */
    tooltipMessageParams: null,

    /**
     * @see AT.UsersSelectorPanel.checkEmail
     */
    checkEmail: false,

    nameMaxLength: null,

    fullNameMaxLength: null,

    /**
     * Returns item's string representation based on name and status properties values
     * @param item item to get name with the status for
     * @return string item's name with the status
     */
    getNameWithStatus: function ( item )
    {
        return this.truncateIfRequired( this.appendStatus( item, this.propertiesController.getName( item ) ),
                                        this.nameMaxLength );
    },

    /**
     * Returns item's string representation based on fullName and status properties values
     * @param item item to get full name with the status for
     * @return string item's full name with the status
     */
    getFullNameWithStatus: function ( item )
    {
        var name = this.propertiesController.getFullName( item );
        name = this.truncateIfRequired( this.checkEmail ? name : this.appendStatus( item, name ),
                                        this.fullNameMaxLength );
        var tooltipMessage = this.getTooltipMessage( item );
        return  concatStr( name, tooltipMessage, " " );
    },

    /**
     * Truncates given string to the <code>maxLength</code>. If <code>maxLength</code> is <code>NULL</code> or not
     * specified returns given string as is
     * @param string
     * @param maxLength
     */
    truncateIfRequired : function ( string, maxLength )
    {
        return maxLength ? truncateStringByLength( string, maxLength ) : string;
    },

    /**
     * Appends item's status to the given string
     * private
     */
    appendStatus: function ( item, string )
    {
        var status = this.getStatusSuffix( item );
        return concatStr( string, status, " " );
    },

    /**
     * Determines whether node is going to be active or not based on given item
     * @param item
     */
    isActive: function(item){
        return this.propertiesController.isActive( item );
    },

    /**
     * Returns item's CSS style class name
     * @param item item to get CSS style class for
     * @return string item's CSS style class
     */
    getStyleClass: function (item){
        if ( this.checkEmail && (!this.propertiesController.getEmail( item ) || !this.isActive(item) ))
            return " without-email ";
        return "";
    },

    /**
     * protected.
     * Returns value of item's property <code>propertyName</code>
     * @param item
     * @param propertyName
     *
     */
    getPropertyValue: function ( item, propertyName )
    {
        return item[ propertyName ];
    },

    /**
     * protected. Should be overwritten by inheritor.
     *
     * Returns null if here is no suffix for the item
     * @param item to get status suffix for
     */
    getStatusSuffix: function ( item )
    {
        //Do nothing by default
        return null;
    },

    /**
     * protected. Should be overwritten by inheritor.
     *
     * Returns null if here is no tooltip message for the item
     * @param item to get tooltip message for
     */
    getTooltipMessage: function ( item )
    {
        var message = null
        if ( !this.isActive(item) && this.tooltipMessageParams )
            message = this.getSingleTooltipMessage( item, "disabled" );
        else if( !this.hasEmail( item ) )
            message = this.getEmailTooltipMessage( item );
        return message;
    },

    setPropertiesController: function ( provider )
    {
        this.propertiesController = provider;
    },

    /**
     * Returns corresponding suffix if item is disabled, null if not.
     * @param item
     */
    getDisabledSuffix: function ( item )
    {
        return this.propertiesController.isActive(item) ?
               null : " " + this.propertiesController.getInactiveSuffixMessage();
    },

    getSingleTooltipMessage: function ( item, messageId )
    {
        return this.tooltipMessageParams[messageId] ?
               messageResource.getMessage(this.tooltipMessageParams[messageId].messageKey,
                                          this.tooltipMessageParams[messageId].params)
               : null;
    },

    getEmailTooltipMessage: function ( item )
    {
        if ( this.tooltipMessageParams && !this.hasEmail( item ) )
            return this.getSingleTooltipMessage( item, "noEmail" ) + "\n";
        return "";
    },

    hasEmail : function( item )
    {
        return !this.checkEmail || this.propertiesController.getEmail( item );
    }

};

export default TreeNodeHelper;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_tree_node_helper.js